export default "__VITE_ASSET__3134bae8__"